import LeftBar from './LeftBar';
import NavBarSearch from './RightBar/NavBarSearch';
import RightBar from './RightBar/RightBar';
import "./NavBar.css";

function NavBar() {
  return (
      <nav className="main-header navbar navbar-expand navbar-white navbar-light nav-height">
        <LeftBar/>
        <RightBar/>
      </nav>
  );
}
export default NavBar;
